<template>
  <footer class="footer">
    <div class="footer__inner">
      <template v-if="type === 'signin'">
        <h3 class="footer__heading">Already have a <span>My Stoke</span> account?</h3>
        <router-link class="buffer-bottom" to="/">Sign in here</router-link>
        <p>Having problems or want help with your <strong>My Stoke</strong> account?</p>
        <a :href="helpURL" >Account help</a>
      </template>

      <template v-else-if="type === 'help'">
        <h3 class="footer__heading">Need help with your <span>My Stoke</span> account?</h3>
        <p>Having problems with your account</p>
        <a class="buffer-bottom" :href="helpURL">Account help</a>
        <p>Want to speak to the ticket office?</p>
        <a href="https://tickets.stokecityfc.com/">Contact Ticket Office</a>
        <p class="footer__telephone">01782 367599</p>
      </template>
      <div class="legalLinks">
        <a href="https://www.stokecityfc.com/privacypolicy">Privacy Policy</a> &nbsp;
        <a href="https://www.stokecityfc.com/club/directory/">Contact Us</a>
      </div>
      <div class="legalLinks">
      This website is © Stoke City FC {{year}}. All rights reserved
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterShout',
  data () {
    var d = new Date();
    return {
      helpURL: 'mailto:tickets@stokecityfc.com',
      year: d.getFullYear()
    }
  },
  props: {
    type: {
      type: String, // register | signin | help
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .footer {
    position: relative;
    margin: 50px 0 0;
    padding: 60px 20px 80px;
    color: #fff;
    font-size: 18px;
    text-align: center;
    background-color: #322024;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: transparent url('../assets/stadium-white-out@2x.png') center right no-repeat;
      background-size: cover;
      opacity: 0.4;
      z-index: 1;
    }

    &__inner {
      position: relative;
      z-index: 3;
    }

    &__heading {
      margin: 0 0 24px;
      font-size: 32px;
      font-weight: 300;

      > span {
        font-weight: 500;
      }
    }

    a {
      color: #fff;

      &:hover {
        color: #D7172F;
      }
    }

    &__telephone {
      margin: 10px 0 0;
      font-size: 34px;
      font-weight: 300;
    }
  }

  .buffer-bottom {
    display: inline-block;
    margin-bottom: 30px;
  }

  .features {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: flex-start;
    margin: 40px auto 0;
    padding: 0;
    max-width: 1200px;
    list-style: none;

    &__item {
      flex-grow: 1;
      flex-basis: 0;
      margin: 0 20px 30px;
      font-size: 15px;
      font-style: normal;
      font-weight: normal;
      line-height: 1.47;
      text-align: center;

      span {
        display: block;
      }

      &:before {
        content: '';
        display: block;
        margin: 0 auto 10px;
        height: 97px;
        width: 97px;
        background-color: rgba(255, 255, 255, 0.75);
        background-position: 50%;
        background-repeat: no-repeat;
        border: 2px solid #fff;
        border-radius: 50%;
      }

      &--store:before {
        background-image: url('../assets/features/retail.svg');
        background-size: 62px;
        background-position: 50% 45%;
      }

      &--plus:before {
        background-image: url('../assets/features/stoke-plus.svg');
        background-size: 62px;
        background-position: 50% 45%;
      }

      &--live:before {
        background-image: url('../assets/features/stoke-live.svg');
        background-size: 62px;
        background-position: 50% 45%;
      }

      &--app:before {
        background-image: url('../assets/features/app.svg');
        background-size: 62px;
      }

      &--ticketing:before {
        background-image: url('../assets/features/tickets.svg');
        background-size: 62px;
      }
    }
  }
  .legalLinks{
    margin-top: 20px;
    font-size: 1.0rem;
  }

  .button {
    a:hover {
      color: #322024 !important;
    }
  }
</style>